import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Goods Lift",
  intro : [
    "Hydraulic Goods Lift is a fix structure used to shift materials from one floor to another. The Single Mast Goods Lift has one side Hydraulic Cylinder with guide structures of “C” Channels.",
  ],
  features: [
    "Limit switches on each floor and door are provided.",
    "Railings or Doors or cabin are provided as per user requirement.",
    "Standard Make raw materials are used.",
    "A MS Stand is provided for safe mounting of Power Pack and Panel.",
    "24V electric circuit is used with overload motor protection for safe operation.",
    "Fully customised as per requirement."
  ],
  structure:[
    "Goods Lift's Main part i.e. Guide channels are standard VSP/SAIL (E250A grade) make with MS Guide rollers.",
    "Mast and Forks are made of heavy 5mm Thick MS Pipes and 10mm thick flat bars.",
    "Top platform with railings are made of MS Pipes, and Sheet.",
    "If it is required to cover the goods lift with structure it can be made from MS sheets, Wire-mesh, MS Pipes and Angles.",
    "MS Square Bar and Round bars are used to make chain pulley set.",
    "12B-2 Series Heavy chains are used as regular. 16B-2 Series chains will be used if Capacity requires.",
  ],
  imageUrl: "/images/goods-lift.png"
}

const GoodsLift = () => {
  return (
  <>
  <DetailCard lists={value} />
  </>
  )
}

export default GoodsLift